<div class="success-container">
  <div class="success-card">
    <div class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img src="assets/images/edu-logo.svg" alt="NDE logo" class="img-fluid" />
            </div>
        </div>
    
   <div class="success-content">
      <div class="success-icon">
          <img src="assets/images/checkmark.png" alt="success" class="img-fluid " />
      </div>
      <h1 class="success-title">Registration Successful</h1>
      <p class="success-message">
        Your account has been created successfully. Please log in to continue.
      </p>
      <button type="button" class="btn btn-primary" (click)="goToLogin()">Log In</button>
      <!-- <div class="loading-container">
        <img src="assets/images/loading-spinner.gif"
             alt="Loading"
             class="loading-gif">
      </div> -->
    </div>
  </div>
</div>
